"use client";
import { useState } from "react";
import Image from "next/image";
import { motion } from "framer-motion";
import { XMarkIcon } from "@heroicons/react/24/solid";
import SectionTitleComp from "./section-title.comp";
import PhotoCardComp from "./photo-card.comp";
import LeftButtonComp from "./left-button.comp";
import PaginationComp from "./pagination.comp";
import { useRouter } from "next/navigation";

export default function GalleryComp({
  images,
  categories,
  pagination
}: {
  images: any[];
  categories: any[];
  pagination: any
}) {
  const router = useRouter();
  const [selectedImage, setSelectedImage] = useState<any | null>(null);
  const [selectedCategory, setSelectedCategory] = useState<any | null>(categories[0]);

  const handleFilterPhoto = (item: any) => {
    setSelectedCategory(item);
    router.push(`/photo?category=${item.slug}`)
  }

  return (
    <div className="">
      <div className="grid grid-cols-1 lg:grid-cols-4 gap-8">
        <div>
          <SectionTitleComp title="Kategori" />
          <div className="grid grid-flow-row gap-4">
            {categories.map((c) => (
              <LeftButtonComp
                key={c.id}
                item={c}
                onClick={(selected: any) => handleFilterPhoto(selected)}
                selectedItem={selectedCategory}
              />
            ))}
          </div>
        </div>
        <div className="lg:col-span-3">
          <p className="font-medium text-lg">{selectedCategory?.name}</p>
          <p className="mb-4">{selectedCategory?.description}</p>
          <div className="grid grid-cols-2 lg:grid-cols-3 gap-4">
          {images.map((src) => (
              <PhotoCardComp
                key={src.id}
                item={src}
                onClick={(selected: any) => setSelectedImage(selected)}
              />
            ))}
          </div>
          {pagination && (<div className="mt-10 relative">
            <PaginationComp
              path={`/photo`}
              otherParams={selectedCategory && selectedCategory.slug !== "" ? `&category=${selectedCategory.slug}` : ""}
              currentPage={pagination.page}
              totalPages={pagination.pageCount}
            />
          </div>)}
          
        </div>
      </div>

      {selectedImage && (
        <div className="fixed inset-0 flex items-center justify-center bg-dark bg-opacity-80 p-4 z-50">
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.9 }}
            className="relative max-w-3xl w-full bg-white p-4 rounded-xl lg:rounded-2xl"
          >
            <button
              className="absolute -top-3 -right-3 text-white bg-gray-800 p-2 rounded-full"
              onClick={() => setSelectedImage(null)}
            >
              <XMarkIcon className="size-6" />
            </button>
            <Image
              src={selectedImage.originalImageSrc}
              alt="Selected Preview"
              width={800}
              height={600}
              className="rounded-lg object-contain w-full h-auto max-h-[80vh]"
            />
            <div className="mt-2">
              <p className="text-lg">{selectedImage.caption}</p>
              <p className="text-gray-700">{selectedImage.description}</p>
            </div>
            
          </motion.div>
        </div>
      )}
    </div>
  );
}
